export default __webpack_public_path__ + "static/object-tile-anatomy-dark-eba2214a9a3cd96446def14aec2b2bf9.png";